<template>
    <form>
        <div class="field">
            <label class="label">Name</label>
            <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                <input v-model="user.name"
                       v-bind:class="{ 'is-danger': errors.name }"
                       class="input"
                       type="text"
                       placeholder="Enter name">
                <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                </span>
                <p v-if="errors.name" class="help is-danger">{{ errors.name[0] }}</p>
            </div>
        </div>
        <div class="field">
            <label class="label">Email</label>
            <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                <input v-model="user.email"
                       v-bind:class="{ 'is-danger': errors.email }"
                       class="input"
                       type="email"
                       placeholder="Enter email">
                <span class="icon is-small is-left">
                    <i class="fas fa-envelope"></i>
                </span>
                <p v-if="errors.email" class="help is-danger">{{ errors.email[0] }}</p>
            </div>
        </div>
        <div class="field">
            <label class="label">Phone</label>
            <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                <input v-model="user.phone"
                       v-bind:class="{ 'is-danger': errors.phone }"
                       class="input"
                       type="number"
                       placeholder="Phone"
                       required=""
                       autofocus="">
                <span class="icon is-left">
                    <i class="fas fa-phone"></i>
                </span>
                <p v-if="errors.phone" class="help is-danger">{{ errors.phone[0] }}</p>
            </div>
        </div>
        <div class="field">
            <label class="label">Type</label>
            <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                <div class="select is-fullwidth">
                    <select v-model="user.type"
                            v-bind:class="{ 'is-danger': errors.type }">
                        <option :value="this.$userTypeIndividual">Individual</option>
                        <option :value="this.$userTypeProfessional">Professional</option>
                        <option :value="this.$userTypeOther">Other</option>
                    </select>
                </div>
                <span class="icon is-left">
                    <i class="fas fa-user"></i>
                </span>
                <p v-if="errors.type" class="help is-danger">{{ errors.type[0] }}</p>
            </div>
        </div>
        <div class="field">
            <label class="label">Company</label>
            <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                <input v-model="user.company"
                       v-bind:class="{ 'is-danger': errors.company }"
                       class="input"
                       type="text"
                       required=""
                       placeholder="Company name">
                <span class="icon is-left">
                    <i class="fas fa-briefcase"></i>
                </span>
                <p v-if="errors.company" class="help is-danger">{{ errors.company[0] }}</p>
            </div>
        </div>
        <div class="field">
            <label class="label">Country</label>
            <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                <div class="select is-fullwidth" v-bind:class="{ 'is-danger': errors.country }">
                    <select v-model="user.country">
                        <option value="" hidden disabled>Country</option>
                        <option v-for="country in countries">{{ country.name }}</option>
                    </select>
                </div>
                <span class="icon is-left">
                    <i class="fas fa-globe"></i>
                </span>
                <p v-if="errors.country" class="help is-danger">{{ errors.country[0] }}</p>
            </div>
        </div>
        <div class="field">
            <button class="button is-fullwidth is-primary" :class="{ 'is-loading': isLoading }" @click.prevent="updateUser">Update Information</button>
        </div>
    </form>
</template>

<script>
    import apiUsers from '../../api/apiUsers'
    import axios from 'axios'
    export default {
        data() {
            return {
                countries: [],
                user: {
                    name: this.$store.getters.getCurrentUser.info.name,
                    email: this.$store.getters.getCurrentUser.info.email,
                    phone: this.$store.getters.getCurrentUser.info.details.phone,
                    type: this.$store.getters.getCurrentUser.info.details.type,
                    company: this.$store.getters.getCurrentUser.info.details.company,
                    country: this.$store.getters.getCurrentUser.info.details.country
                },
                errors: {
                    name: '',
                    email: '',
                    phone: '',
                    type: '',
                    company: '',
                    country: ''
                },
                isLoading: false,
            }
        },
        methods: {
            updateUser () {
                this.isLoading = true
                this.clearAllErrors()
                apiUsers.
                    userUpdateByUserRequest(this.user)
                    .then(response => {
                        this.isLoading = false
                    })
                    .catch((err) => {
                        this.isLoading = false
                        if ( err.response && err.response.status === 422 ) {
                            this.errors = err.response.data
                            console.log(err.response.data);
                        }
                    })

            },
            clearAllErrors() {
                this.errors = {
                        name: '',
                        email: '',
                        phone: '',
                        type: '',
                        company: '',
                        country: ''
                }
            }
        },
        mounted () {
            axios.get('https://restcountries.com/v3.1/all?fields=name')
                .then((response) => {
                    this.countries = response.data
                })
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Profile/Contacts.vue